export default __webpack_public_path__ + "static/englanderLogo-0d76d5022d873c1538731d99c66c022b.svg";